import './styles/global.css';
import { createRef, useEffect } from 'react';

import Default from 'layouts/Default';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useSelector } from 'react-redux';
import Routes from 'routes';
import { ENV } from 'settings';
import AlertDialog, { IAlertDialog } from 'shared/AlertDialog';
import { HoustonThemeProvider } from 'shared/Houston';
import { LoadingPage } from 'shared/PageLoader';
import { PageWrapper } from 'styles';
import { enEnviroment } from 'types/enums';
import { checkCookies } from 'utils/Cookies';

import { IHoustonTheme } from '@eduzz/houston-styles';
import createTheme from '@eduzz/houston-styles/createTheme';

import { selectIsLogged, selectUser } from './store/selectors/user/index';

import './hooks/useMediaQuery';
import './services/auth';

function App() {
  const client = new QueryClient();
  const refAlertDialog = createRef<IAlertDialog>();
  const isLogged = useSelector(selectIsLogged);
  const { isLoading } = useSelector(selectUser);

  useEffect(() => {
    if (isLogged && !checkCookies()) {
      refAlertDialog.current?.showAlertDialog({
        title: 'Cookies desabilitados',
        text: 'Habilite os cookies para ter uma experiência completa em nossa plataforma',
        confirmActionTextButton: 'Ok',
        hideCancelButton: true
      });
    }
  }, [refAlertDialog, isLogged]);
  if (ENV === enEnviroment.PROD && window?.hj) {
    window.hj('trigger', 'chk_admin_trigger_prod');
  }

  if (!isLogged) {
    return null;
  }

  const theme: IHoustonTheme = createTheme('orbita');

  if (!isLogged) {
    return (
      <HoustonThemeProvider theme={theme}>
        <LoadingPage />
      </HoustonThemeProvider>
    );
  }

  return (
    <QueryClientProvider client={client}>
      <HoustonThemeProvider theme={theme}>
        {isLogged && isLoading && <LoadingPage />}
        <Default>
          <PageWrapper spacing='comfortable'>
            <Routes />
          </PageWrapper>
        </Default>
        <AlertDialog ref={refAlertDialog} />
      </HoustonThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
